export default function eventDetails() {
  return {
    eventData: [],
    currentPageURLPart: "",
    totalCount: 0,
    pageCount: 0,
    currentPage: 1,
    hasMore: false,

    currentPageURLPartName() {
      var currentURL = window.location.href;
      var parts = currentURL.split("=");
      var value = parts[parts.length - 1];

      this.currentPageURLPart = value;

      return this.currentPageURLPart;
    },
    formatDate(dateValue) {
      const options = { month: "long", day: "numeric", year: "numeric" };
      const formattedDate = new Date(dateValue).toLocaleDateString(
        undefined,
        options
      );
      return formattedDate;
    },
    getEventbySerialId() {
      var serialId = this.currentPageURLPartName();

      fetch("/api/EventsAPI/GetEventDetails?serialNumber=" + serialId, {
        method: "GET",
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
        })
        .then((response) => {
          /*Array.prototype.push.apply(this.eventData, response.eventDetail);*/
          this.eventData.push(response.eventDetail);
        });
    },

    init() {
      this.getEventbySerialId();
    },
  };
}
